/*
 * @Descripttion: zzy
 * @version:  v3.2
 * @Author: zzy
 * @Date: 2025-06-20 13:55:51
 * @LastEditors: zzy
 * @LastEditTime: 2025-07-01 16:14:09
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/style.css'
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/element-variables.scss'//自定义el-ui主题
 
Vue.use(ElementUI);



Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
